import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, CheckCircle2, Check } from 'lucide-react';
import { siteData } from '../mock/data';
import ScrollReveal, { ImageReveal } from '../components/ScrollReveal';
import ContactBlock from '../components/ContactBlock';

const About = () => {
  const { about } = siteData;
  const lightValues = about.values.slice(0, 4);
  const darkValues = about.values.slice(4);
  return (
    <>
      {/* HERO */}
      <section className="pt-40 pb-24">
        <div className="container-x">
          <div className="font-mono-up text-[#0A2A28]/60 mb-8 hero-eyebrow">
            <span className="gold-line" />{about.eyebrow}
          </div>
          <h1 className="font-display text-[12vw] md:text-[9vw] leading-[0.92] text-[#0A2A28] -tracking-[0.02em]">
            <span className="hero-title block">{about.title}</span>
            <span className="hero-title-2 block font-serif-italic text-[#BFA070]">{about.titleAccent}</span>
          </h1>
          <div className="grid md:grid-cols-12 gap-10 mt-14 hero-para">
            <div className="md:col-span-6 md:col-start-6">
              <p className="text-[#0A2A28]/80 text-lg leading-relaxed mb-5">{about.intro}</p>
              <p className="text-[#0A2A28]/70 leading-relaxed">{about.intro2}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values light */}
      <section className="section bg-[#EFE9DE]">
        <div className="container-x">
          <ScrollReveal>
            <div className="font-mono-up text-[#0A2A28]/60 mb-6">
              <span className="gold-line" />Häuser verwalten
            </div>
          </ScrollReveal>
          <ScrollReveal delay={1}>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] text-[#0A2A28] mb-16">
              Werte <span className="font-serif-italic text-[#BFA070]">betreuen.</span>
            </h2>
          </ScrollReveal>
          <div className="grid md:grid-cols-2 gap-[1px] bg-[#0A2A28]/10">
            {lightValues.map((v, i) => (
              <ScrollReveal key={v} delay={(i % 3) + 1}>
                <div className="bg-[#EFE9DE] p-10 flex items-start gap-5 group">
                  <CheckCircle2 size={26} strokeWidth={1.25} className="text-[#BFA070] flex-shrink-0 mt-1" />
                  <div>
                    <div className="lux-num mb-2">0{i + 1}</div>
                    <h3 className="font-display text-3xl leading-tight text-[#0A2A28] group-hover:text-[#BFA070] transition-colors">
                      {v}
                    </h3>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Values dark */}
      <section className="section dark-section radial-glow">
        <div className="container-x">
          <div className="grid md:grid-cols-3 gap-[1px] bg-[#E8E2D5]/10">
            {darkValues.map((v, i) => (
              <ScrollReveal key={v} delay={(i % 3) + 1}>
                <div className="bg-[#0A2A28] p-10 flex items-start gap-5 group hover:bg-[#0F3A37] transition-colors duration-500">
                  <Check size={26} strokeWidth={1.25} className="text-[#BFA070] flex-shrink-0 mt-1" />
                  <div>
                    <div className="lux-num mb-2">0{i + 5}</div>
                    <h3 className="font-display text-2xl md:text-3xl leading-tight text-[#E8E2D5] group-hover:text-[#BFA070] transition-colors">
                      {v}
                    </h3>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Region */}
      <section className="section">
        <div className="container-x grid md:grid-cols-12 gap-16 items-center">
          <div className="md:col-span-6">
            <ScrollReveal>
              <div className="font-mono-up text-[#0A2A28]/60 mb-6">
                <span className="gold-line" />Region
              </div>
            </ScrollReveal>
            <ScrollReveal delay={1}>
              <h2 className="font-display text-5xl md:text-7xl leading-[0.95] text-[#0A2A28] mb-8">
                {about.region.title.split(' ')[0]} <br />
                <span className="font-serif-italic text-[#BFA070]">Düsseldorf.</span>
              </h2>
            </ScrollReveal>
            <ScrollReveal delay={2}>
              <p className="text-[#0A2A28]/75 text-lg leading-relaxed mb-8">{about.region.text}</p>
            </ScrollReveal>
            <ScrollReveal delay={3}>
              <div className="flex flex-wrap gap-2 mb-10">
                {['Düsseldorf', 'Ratingen', 'Essen', 'Mönchengladbach'].map((c) => (
                  <span key={c} className="px-5 py-2 border border-[#0A2A28]/20 font-mono-up text-[#0A2A28]">
                    {c}
                  </span>
                ))}
              </div>
              <Link to="/objekte" className="lux-btn">
                <span>Mehr erfahren</span>
                <ArrowUpRight className="arrow" size={16} strokeWidth={1.5} />
              </Link>
            </ScrollReveal>
          </div>
          <div className="md:col-span-6">
            <ImageReveal src={about.region.image} alt="Düsseldorf" className="aspect-[4/5]" />
          </div>
        </div>
      </section>

      <ContactBlock />
    </>
  );
};

export default About;
